import React from 'react';
import siteContent from '../data/siteContent';
import './Nav.css';

const LogoMark = () => (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="31" cy="31" r="28" stroke="#00aaff" strokeWidth="0.6" opacity="0.2"/>
    <circle cx="31" cy="31" r="22" stroke="#00aaff" strokeWidth="0.8" opacity="0.35"/>
    <line x1="3" y1="31" x2="59" y2="31" stroke="#00aaff" strokeWidth="0.5" opacity="0.2"/>
    <line x1="31" y1="3" x2="31" y2="59" stroke="#00aaff" strokeWidth="0.5" opacity="0.2"/>
    <line x1="10" y1="10" x2="52" y2="52" stroke="#00aaff" strokeWidth="0.5" opacity="0.15"/>
    <line x1="52" y1="10" x2="10" y2="52" stroke="#00aaff" strokeWidth="0.5" opacity="0.15"/>
    <polygon points="31,3 59,31 31,59 3,31" stroke="#00aaff" strokeWidth="1.2" fill="none" opacity="0.5"/>
    <polygon points="31,13 49,31 31,49 13,31" stroke="#00aaff" strokeWidth="1.2" fill="rgba(0,170,255,0.08)"/>
    <line x1="31" y1="31" x2="31" y2="3"  stroke="#00aaff" strokeWidth="1" opacity="0.85"/>
    <line x1="31" y1="31" x2="59" y2="31" stroke="#00aaff" strokeWidth="1" opacity="0.85"/>
    <line x1="31" y1="31" x2="31" y2="59" stroke="#00aaff" strokeWidth="1" opacity="0.85"/>
    <line x1="31" y1="31" x2="3"  y2="31" stroke="#00aaff" strokeWidth="1" opacity="0.85"/>
    <line x1="31" y1="31" x2="52" y2="10" stroke="#00aaff" strokeWidth="0.7" opacity="0.5"/>
    <line x1="31" y1="31" x2="52" y2="52" stroke="#00aaff" strokeWidth="0.7" opacity="0.5"/>
    <line x1="31" y1="31" x2="10" y2="10" stroke="#00aaff" strokeWidth="0.7" opacity="0.5"/>
    <line x1="31" y1="31" x2="10" y2="52" stroke="#00aaff" strokeWidth="0.7" opacity="0.5"/>
    <circle cx="31" cy="3"  r="3" fill="#00aaff"/>
    <circle cx="59" cy="31" r="3" fill="#00aaff"/>
    <circle cx="31" cy="59" r="3" fill="#00aaff"/>
    <circle cx="3"  cy="31" r="3" fill="#00aaff"/>
    <circle cx="52" cy="10" r="2" fill="#00aaff" opacity="0.6"/>
    <circle cx="52" cy="52" r="2" fill="#00aaff" opacity="0.6"/>
    <circle cx="10" cy="10" r="2" fill="#00aaff" opacity="0.6"/>
    <circle cx="10" cy="52" r="2" fill="#00aaff" opacity="0.6"/>
    <circle cx="31" cy="31" r="6" fill="rgba(0,170,255,0.12)" stroke="#00aaff" strokeWidth="1.2"/>
    <circle cx="31" cy="31" r="3" fill="#00aaff"/>
  </svg>
);

export default function Nav() {
  const { name } = siteContent.company;
  const [first, second] = name.split(' ');

  return (
    <nav className="nav">
      <a href="/" className="nav-logo">
        <div className="logo-mark"><LogoMark /></div>
        <span className="logo-text">{first}<span className="logo-accent"> {second}</span></span>
      </a>
      <ul className="nav-links">
        <li><a href="#about">About</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#sectors">Sectors</a></li>
        <li><a href="#contact" className="nav-cta">Contact Us</a></li>
      </ul>
    </nav>
  );
}
